import { useCallback } from 'react';
import * as Role from '../../../../../constants/role';
import * as Status from '../../../../../constants/status';
import { isDigitadorVinculado } from '../../utils/servicosPermissions';
import { pickDigitacaoPayload } from '../utils/pickDigitacaoPayload';

/**
 * Decide PATCH digitacao vs PUT completo e delega às actions Redux.
 * Fecha/avança apenas após callback de sucesso da saga.
 */
export const useMtBtSave = ({
  nsirStatus,
  digitadorId,
  userId,
  userRole,
  nsirId,
  digitarNsmp,
  updateNsmp,
  saveNsmp,
  onSuccess,
  onReatribuida,
}) => {
  const shouldUsePatch = useCallback(
    () =>
      nsirStatus === Status.EM_DIGITACAO
      && isDigitadorVinculado({ userRole, digitadorId, userId })
      && userRole === Role.DIGITADOR,
    [nsirStatus, digitadorId, userId, userRole],
  );

  const savePayload = useCallback(
    (data, { advanceNext } = {}) => {
      const afterSuccess = (ok, result, statusCode) => {
        if (statusCode === 409) {
          onReatribuida?.(result);
          return;
        }
        if (ok) {
          onSuccess?.(result, { advanceNext });
        }
      };

      if (data?.id && shouldUsePatch()) {
        digitarNsmp({
          ...pickDigitacaoPayload(data),
          nsirId,
          callback: afterSuccess,
        });
        return;
      }

      const payload = { ...data, nsirId };
      if (data?.id) {
        updateNsmp(payload, afterSuccess);
      } else if (data) {
        saveNsmp(payload, afterSuccess);
      }
    },
    [
      shouldUsePatch,
      digitarNsmp,
      updateNsmp,
      saveNsmp,
      nsirId,
      onSuccess,
      onReatribuida,
    ],
  );

  return { shouldUsePatch, savePayload };
};

export default useMtBtSave;
